export default __webpack_public_path__ + "static/66219-58cd7f0f656e41ce27dd024faa5a523e.jpg";